export enum RiskTypeId {
  AddressRisk = 1,
  MissingPickupTimeRisk = 2,
  DriverHotelRisk = 3,
  FlightRisk = 4,
  DOTComplianceRisk = 5,
  IncompleteStopRisk = 6,
  MissingStopRisk = 7,
}

export enum ChargeTypeId {
  BaseFare = 1,
  Lodging = 2,
  Tolls = 3,
  ProcessingFee = 4,
  Parking = 5,
  Misc = 6,
  Gratuity = 7,
  Time = 8,
  Personnel = 9,
  Equipment = 10,
  TripChange = 11,
  RefundAdjustment = 12,
  Overtime = 13,
  CleaningFee = 14,
  Discount = 15,
  FuelSurcharge = 16,
  Wifi = 17,
  Markup = 18,
  CancellationPenalty = 19,
  Amenities = 20,
  DiscountCoupon = 21,
  UpdatedReferralPriceAdjustment = 22,
  TrackedOnTimeAdjustment = 24,
  PST = 25,
  GST = 26,
  HST = 27,
  QST = 28,
}

export enum ChargeTypeKey {
  BaseFare = "base_fare",
  Lodging = "lodging",
  Tolls = "tolls",
  ProcessingFee = "processing_fees",
  Parking = "parking",
  Misc = "misc",
  Gratuity = "gratuity",
  Time = "time",
  Personnel = "personnel",
  Equipment = "equipment",
  TripChange = "trip_change",
  RefundAdjustment = "refund_adjustment",
  Overtime = "overtime",
  CleaningFee = "cleaning_fees",
  Discount = "discount",
  FuelSurcharge = "fuel",
  Wifi = "wi-fi",
  Markup = "markup",
  CancellationPenalty = "cancellation_penalty",
  Amenities = "amenities",
  DiscountCoupon = "discount_coupon",
  UpdatedReferralPriceAdjustment = "updated_referral_price_adjustment",
  TrackedOnTimeAdjustment = "tracked_on_time_adjustment",
  PST = "pst",
  GST = "gst",
  HST = "hst",
  QST = "qst",
}

export const ChargeTypeMap = {
  [ChargeTypeId.BaseFare]: ChargeTypeKey.BaseFare,
  [ChargeTypeId.Lodging]: ChargeTypeKey.Lodging,
  [ChargeTypeId.Tolls]: ChargeTypeKey.Tolls,
  [ChargeTypeId.ProcessingFee]: ChargeTypeKey.ProcessingFee,
  [ChargeTypeId.Parking]: ChargeTypeKey.Parking,
  [ChargeTypeId.Misc]: ChargeTypeKey.Misc,
  [ChargeTypeId.Gratuity]: ChargeTypeKey.Gratuity,
  [ChargeTypeId.Time]: ChargeTypeKey.Time,
  [ChargeTypeId.Personnel]: ChargeTypeKey.Personnel,
  [ChargeTypeId.Equipment]: ChargeTypeKey.Equipment,
  [ChargeTypeId.TripChange]: ChargeTypeKey.TripChange,
  [ChargeTypeId.RefundAdjustment]: ChargeTypeKey.RefundAdjustment,
  [ChargeTypeId.Overtime]: ChargeTypeKey.Overtime,
  [ChargeTypeId.CleaningFee]: ChargeTypeKey.CleaningFee,
  [ChargeTypeId.Discount]: ChargeTypeKey.Discount,
  [ChargeTypeId.FuelSurcharge]: ChargeTypeKey.FuelSurcharge,
  [ChargeTypeId.Wifi]: ChargeTypeKey.Wifi,
  [ChargeTypeId.Markup]: ChargeTypeKey.Markup,
  [ChargeTypeId.CancellationPenalty]: ChargeTypeKey.CancellationPenalty,
  [ChargeTypeId.Amenities]: ChargeTypeKey.Amenities,
  [ChargeTypeId.DiscountCoupon]: ChargeTypeKey.DiscountCoupon,
  [ChargeTypeId.UpdatedReferralPriceAdjustment]: ChargeTypeKey.UpdatedReferralPriceAdjustment,
  [ChargeTypeId.TrackedOnTimeAdjustment]: ChargeTypeKey.TrackedOnTimeAdjustment,
  [ChargeTypeId.PST]: ChargeTypeKey.PST,
  [ChargeTypeId.GST]: ChargeTypeKey.GST,
  [ChargeTypeId.HST]: ChargeTypeKey.HST,
  [ChargeTypeId.QST]: ChargeTypeKey.QST,
}

export enum VehicleTypeId {
  CharterBus = 1,
  MiniBus = 2,
  Sprinter = 3,
  PartyBus = 4,
  Sedan = 5,
  SUV = 6,
  Limousine = 7,
  Trolley = 8,
  SchoolBus = 9,
  Van = 10,
}

export enum VehicleTypeKey {
  CharterBus = 'charter_bus',
  MiniBus = 'mini_bus',
  Sprinter = 'sprinter',
  PartyBus = 'party_bus',
  Sedan = 'sedan',
  SUV = 'suv',
  Limousine = 'limousine',
  Trolley = 'trolley',
  SchoolBus = 'school_bus',
  Van = 'van',
}

export enum VehicleTypeLabel {
  CharterBus = 'Charter Bus',
  MiniBus = 'Mini Bus',
  Sprinter = 'Sprinter',
  PartyBus = 'Party Bus',
  Sedan = 'Sedan',
  SUV = 'SUV',
  Limousine = 'Limousine',
  Trolley = 'Trolley',
  SchoolBus = 'School Bus',
  Van = 'Van',
}

export enum TripTypeId {
  OneWay = 1,
  RoundTrip = 2,
  Hourly = 3,
  Daily = 4,
  Shuttle = 5,
  LargeEvent = 6,
  LongTermShuttle = 7,
}

export enum TripTypeLabel {
  OneWay = 'One Way',
  RoundTrip = 'Round Trip',
  Hourly = 'Hourly',
  Daily = 'Daily',
  Shuttle = 'Shuttle',
  LargeEvent = 'Large Event',
  LongTermShuttle = 'Long Term Shuttle',
}

export enum AmenityTypeId {
  Wifi = 1,
  Luggage = 2,
  Bathroom = 3,
  SeatBelts = 4,
  ADA = 5,
  TVScreens = 6,
  Outlets = 7,
  LeatherSeats = 8,
  CDC = 9,
  DOD = 10,
  SPAB = 11,
  AlcoholConsumption = 12,
  MountainDriver = 13,
  NineteenACertification = 14,
  AuxBluetooth = 15,
  PASystem = 16,
  BottledWater = 17,
  MakeModelYear = 18,
  BusColor = 19,
  BusLogos = 20,
  NonStandard = 21,
  TripCoordinators = 22,
  BusWraps = 23,
  VehicleStaysOnSite = 24,
  ACHeat = 25,
}

export enum AmenityTypeKey {
  Wifi = 'wifi',
  Luggage = 'luggage',
  Bathroom = 'lavatory',
  SeatBelts = 'seatbelts',
  ADA = 'ada',
  TVScreens = 'tv_screens',
  Outlets = 'outlets',
  LeatherSeats = 'leather_seats',
  CDC = 'cdc',
  DOD = 'dod',
  SPAB = 'spab',
  AlcoholConsumption = 'alcohol_allowed',
  MountainDriver = 'mountain_driver',
  NineteenACertification = '19a_certification',
  AuxBluetooth = 'aux_bluetooth',
  PASystem = 'pa_system',
  BottledWater = 'bottled_water',
  MakeModelYear = 'make_model_year',
  BusColor = 'vehicle_color',
  BusLogos = 'vehicle_logos',
  NonStandard = 'non_standard_vehicle_size',
  TripCoordinators = 'trip_coordinators',
  BusWraps = 'wraps',
  VehicleStaysOnSite = 'vehicle_stays_on_site',
  ACHeat = 'ac_heat',
}

export enum paidAmenityTypeIds {
  Wifi = 1,
  LeatherSeats = 8,
  AlcoholAllowed = 12,
}

export enum guaranteedAmenityTypeIds {
  Wifi = 1,
  LeatherSeats = 8,
  AlcoholAllowed = 12,
  SPAB = 11,
  ADA = 5,
  SeatBelts = 4,
  Outlets = 7,
  TVScreens = 6,
  MountainDriver = 13,
  NineteenACertification = 14,
  AuxBluetooth = 15,
  PASystem = 16,
  BottledWater = 17,
  VehicleStaysOnSite = 24
}

export enum bestEffortAmenityTypeIds {
  MakeModelYear = 18,
  BusColor = 19,
  BusLogos = 20,
  NonStandard = 21,
  TripCoordinators = 22,
  BusWraps = 23
}

export enum VehicleAmenityTypeIds {
  Wifi = 1,
  Luggage = 2,
  Bathroom = 3,
  SeatBelts = 4,
  ADA = 5,
  TVScreens = 6,
  Outlets = 7,
  LeatherSeats = 8,
  CDC = 9,
  DOD = 10,
  AuxBluetooth = 15,
  PASystem = 16,
  MakeModelYear = 18,
  BusColor = 19,
  BusLogos = 20,
  NonStandard = 21,
  BusWraps = 23
}

export enum CreditCardType {
  Visa = 'visa',
  Mastercard = 'mastercard',
  Discover = 'discover',
  AmericanExpress = 'amex',
  Diners = 'diners',
  Default = 'default',
}

export enum KeyCode {
  Enter = 13,
  Escape = 27,
  ArrowLeft = 37,
  ArrowUp = 38,
  ArrowRight = 39,
  ArrowDown = 40,
}

export enum ReservationStatus {
  Upcoming = 'UPCOMING',
  Started = 'STARTED',
  Finished = 'FINISHED',
}

export enum ReservationTrackingAllocation {
  All = 'ALL',
  Partial = 'PARTIAL',
  None = 'NONE',
}

export enum ProviderConflict {
  Partial = 'partial',
  Complete = 'complete',
  None = 'none',
}

export enum CompanyId {
  CharterUP = 2,
}

export enum PartnerTypeId {
  GoldReseller = 1,
  SilverReseller = 2,
  BronzeReseller = 13,
  Platinum = 3,
  Gold = 4,
  Silver = 5,
  Bronze = 6,
  NonPartner = 7,
  Banned = 11
}

export enum SplitTrafficType {
  Anonymous = 'anonymous',
  User = 'user',
}

export enum SplitKeyType {
  AnonymousUser = 'anonymous',
}

export enum SplitFeatureFlag {
  ShowNotAuthorizedOperators = 'default-show-unauthorized-operators',
  VehicleVinOverride = 'vehicle-vin-override',
  TripMonitoringAutomatedCalls = 'trip-monitoring-ai-calls',
  LoopingShuttleItineraries = 'looping-shuttle-itineraries',
  CanadaCallQueues = 'canada-call-queues',
  PreTripDriverConfirmationSMS = 'pre-trip-driver-confirmation-sms',
  CanDeleteEldIntegrations = 'can-delete-eld-integrations',
  BlockInternalModManualPricing = 'temporarily-block-manual-pricing',
  VehicleInventory = 'vehicle-inventory',
  ReservationPOToBAS = 'coachrail-convert-reservation-po-to-bas',
  ItineraryModificationsV2Editor = 'itin-mods-allow-v2-editor',
  ContactWizard = 'trip-contact-wizard'
}

export enum PricingMethod {
  SinglePrice = 'single_price',
  Bids = 'bids',
  Category = 'category',
}

export enum SplitEvents {
  QuoteConverted = 'quote-converted',
}

export enum VINReviewStatusKeys {
  Pending = 'pending',
  Rejected = 'rejected',
  Accepted = 'accepted',
  Cancelled = 'cancelled',
}

export enum VINReviewTypes {
  Create = 'create',
  Update = 'update',
}

export enum CancellationRefundPercentage {
  None = 0,
  Full = 1,
}

export enum ValuePropKey {
  BookingProtection = 'booking_protection',
  Tracking = 'tracking',
  LiveSupport = 'live_support',
  QualifiedOperators = 'qualified_operators',
}

export enum CustomerAccountPurpose {
  Demo = 'demo',
  Standard = 'standard',
}

export enum ReservationStopStatus {
  ExpectedOnTime = 'EXPECTED ON TIME',
  OnTime = 'ON TIME',
  Arrived = 'ARRIVED',
  EnRoute = 'EN ROUTE',
  ExpectedLate = 'EXPECTED LATE',
  Late = 'LATE',
  NoTracking = 'NO TRACKING',
  Undetected = 'UNDETECTED',
  Completed = 'COMPLETED',
  ToDo = 'TO DO',
}

export enum InfoModalVariant {
  Simple = 'simple',
  Standard = 'standard',
  Itemized = 'itemized',
  Custom = 'custom',
}

export enum PaymentMethodTypeKey {
  CreditCard = 'credit_card',
  ACH = 'ach',
  Check = 'check',
  Other = 'other',
  Hold = 'hold',
}

export enum PaymentMethodTypeId {
  CreditCard = 1,
  ACH = 2,
  Check = 3,
  Billing = 4,
  Refund = 5,
}

export enum PaymentGatewayTypeKey {
  AuthorizeNet = 'auth_net',
  Finix = 'finix',
}

export enum CheckoutPageId {
  GOGO = 1,
  National = 2,
  Shofur = 3,
}

export enum PaymentTerms {
  Net3 = 'net_3',
  Net14 = 'net_14',
  Net30 = 'net_30',
  Pending = 'pending',
}

export enum ReferralStatus {
  Reoffered = 'reoffered',
  Offered = 'offered',
  Accepted = 'accepted',
  Rejected = 'rejected',
  NotOffered = 'not_offered',
  FullyOffered = 'fully_offered',
  FullyAccepted = 'fully_accepted',
  FullyConfirmed = 'fully_confirmed',
  Confirmed = 'confirmed',
}

export enum PaymentTypeId {
  FullPayment = 1,
  DownPayment = 2,
  BillAfterServices = 3,
  PurchaseOrder = 9
}

export enum PaymentTypeKey {
  FullPayment = 'full_payment',
  DownPayment = 'down_payment',
  BillAfterServices = 'bill_after_services',
  PurchaseOrder = 'purchase_order'
}

export enum PaymentStageKey {
  Unset = 'unset',
  Checkout = 'checkout',
  RemainingBalance = 'remaining_balance',
}

export enum ReservationStatusKey {
  Upcoming = 'upcoming',
  Started = 'started',
  Finished = 'finished',
  Cancelled = 'cancelled',
  OnHold = 'hold',
}

export enum CancellationStatusKey {
  Started = 'started',
  Cancelled = 'cancelled',
}

export enum TicketStatusTypeId {
  Created = 1,
  Open = 2,
  Closed = 3,
  Migrated = 4,
}

export enum TierKey {
  Vip = 'vip',
  Plus = 'plus',
  Standard = 'standard',
}

export enum TierLabel {
  Vip = 'VIP',
  Plus = 'Plus',
  Standard = 'Standard',
}

export enum CompanyTierLabel {
  Tier1 = 'Tier 1',
  Tier2 = 'Tier 2',
  Tier3 = 'Tier 3',
  Tier4 = 'Tier 4'
}

export enum PoStatus {
  Confirmed = "PO Confirmed",
  Received = "PO Received"
}

export enum TripMonitoringTabsHeader {
  Reservation = 'Reservation Details',
  Driver = 'Driver',
  Vehicle = 'Vehicle',
  Provider = 'Provider',
  Tracking = 'Tracking',
}

export enum ContactType {
  Driver = "driver",
  Operator = "operator"
}

export enum VinVerificationType {
  VerificationFailure = "verification_failure",
  VerificationPending = "pending_verification"
}

export enum SpecialRequirementsTypeLabel {
  ADA = 'ADA',
  SPAB = 'SPAB',
  VehicleNeededEntireTrip = 'Vehicle stays on-site',
}

export enum SpecialRequirementsTypeKey {
  ADA = 'ada',
  SPAB = 'spab',
  VehicleNeededEntireTrip = 'vehicle_needed_entire_trip',
}

export enum CheckoutPageKey {
  CharterUP = 'charterup',
  BusDotCom = 'bus.com CA'
}

export enum Currency {
  USD = 'USD',
  CAD = 'CAD'
}

export enum ELDType {
  SAMSARA = 'SAMSARA',
  MOTIVE = 'MOTIVE',
  VERIZON = 'VERIZON',
  GEOTAB = 'GEOTAB',
  SAUCON = 'SAUCON'
}

export enum DriverTrackingSourceType {
  COACHRAIL = 'COACHRAIL',
  BUSIFY = 'BUSIFY'
}

export enum TrackingIndicator {
  GREEN = 'GREEN',
  YELLOW = 'YELLOW',
  RED = 'RED',
  GRAY = 'GRAY'
}

export enum ContactRoleLabel {
  BookingContact = "Booking Contact",
  Account = "Account",
  AuthorizedUser = "Authorized User",
  ViewOnlyUser = "View Only User",
  BillingAccess = "Billing Access User",
  FullAccess = "Full Access User",
}

export enum UserRoles {
  AuthorizedUser = "trip-authorized-user",
  ViewOnlyUser = "trip-view-only-user",
  Editor = "trip-editor",
  TripContact = "trip-contact",
  BillingAccess = "billing-access",
  FullAccess = "full-access",
}

export enum SidebarModes {
  ADD = 'add',
  EDIT = 'edit',
  REMOVE = 'remove',
}

export enum VehicleTypeCapacity {
  CharterBus = 56,
  MiniBus = 28,
  Sprinter = 12,
}


export enum TripModificationRequestStatus {
  Draft = 'draft',
  DraftCustomerPending = 'draft_customer_pending',
  Pending = 'pending',
  Completed = 'completed',
  Cancelled = 'cancelled',
  Rejected = 'rejected',
  Deleted = 'draft_deleted',
  Submitted = 'submitted'
}

export enum TripModificationWizardStep {
    Itinerary = 0,
    Details = 1,
    Review = 2,
    Payment = 3,
    Result = 4
}

export enum TripEventTypeId {
  K12 = 1,
  University = 2,
  Athletics = 3,
  Airlines = 4,
  Military = 5,
  Corporate = 6,
  Personal = 7,
  Wedding = 8,
  AirportTransfer = 9,
  Other = 10,
}

export enum TripEventTypeKey {
  K12 = 'k_12',
  University = 'university',
  Athletics = 'athletics',
  Airlines = 'airlines',
  Military = 'military',
  Corporate = 'corporate',
  Personal = 'personal',
  Wedding = 'wedding',
  AirportTransfer = 'airport_transfer',
  Other = 'other',
}

export const ContactWizardRoles = {
  FullAccess: { key: "full_access", label: "Full Access" },
  BillingAccess: { key: "billing_access", label: "Billing Access" },
  ViewOnly: { key: "view_only", label: "View Only" },
} as const;

export enum VehicleAmenityAttestedStatus {
  Unverified = 'UNVERIFIED',
  DoesNotMeetExpectation = 'DOES_NOT_MEET_EXPECTATION',
  MeetsExpectation = 'MEETS_EXPECTATION',
  UnderReview = 'UNDER_REVIEW',
}
